"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _avlComponents = require("@availabs/avl-components");

var _amsDirectory = _interopRequireDefault(require("../wrappers/ams-directory"));

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _default = (0, _amsDirectory["default"])(function (_ref) {
  var path = _ref.path,
      children = _ref.children,
      user = _ref.user,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "mt-16" : _ref$className,
      props = _objectWithoutProperties(_ref, ["path", "children", "user", "className"]);

  var theme = (0, _avlComponents.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-20"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-block"
  }, _react["default"].Children.toArray(children).reduce(function (accum, child) {
    var showInDirectory = (0, _lodash["default"])(child, ["props", "showInDirectory"], true),
        showIfLoggedIn = (0, _lodash["default"])(child, ["props", "showIfLoggedIn"], true),
        amsAction = (0, _lodash["default"])(child, ["props", "amsAction"]);

    if (amsAction) {
      var authLevel = (0, _lodash["default"])(child, ["props", "authLevel"], -1);

      if (user.authLevel >= authLevel && showInDirectory && (!user.authed || user.authed && showIfLoggedIn)) {
        accum.push( /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          key: child.props.amsAction,
          to: "".concat(path, "/").concat(child.props.amsAction)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "py-1 px-2 rounded hover:".concat(theme.accent1)
        }, child.props.amsAction)));
      } else {
        accum.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: child.props.amsAction,
          className: "py-1 px-2 cursor-not-allowed line-through rounded hover:".concat(theme.accent1)
        }, child.props.amsAction));
      }
    } else if (!amsAction) {
      accum.push(child);
    }

    return accum;
  }, []))));
});

exports["default"] = _default;